module.exports = __webpack_public_path__ + "static/media/checksuc.76644652.svg";